import client from "./client";

export default {

    async propertyUnits(filters) {
        return client.parseResponse(await client.get('/property-units', filters));
    },
    async getPropertyUnit(id) {
        return client.parseResponse(await client.get('/property-units/' + id));
    },
    async getPropertyUnits(data) {
        return client.parseResponse(await client.get('/property-units', data));
    },
    async createPropertyUnit(data) {
        return client.parseResponse(await client.post('/add-property-units', data))
    },

    async createBulkUnits(data) {
        return client.parseResponse(await client.post('/add-bulk-units', data))
    },

    async editPropertyUnit(data) {
        return client.parseResponse(await client.post('/property-units/' + data.get('id') + "?_method=PUT", data, {
            'Content-Type': 'multipart/form-data'
        }))
    },

    async deletePropertyUnit(unit) {
        return client.parseResponse(await client.delete('/property-units/' + unit.id))
    }
}
